angular.module('komondor-access')

.factory('usersViewOptions', function (
    resourceViewOptions,
    extendDeep,
    $window,
    $http,
    notify,
    DS,
    listView,
    kdLogin,
    createAction
) {
    var customCreateAction = angular.copy(createAction);
    customCreateAction.template = '<i class="material-icon material-icon-add"></i> New user';

    var options = extendDeep(angular.copy(resourceViewOptions), {
        title: 'Users',
        with: ['role'],
        toolbar: [customCreateAction],
        list: {
            columns: [
                {
                    label: 'Name',
                    name: 'name',
                    sortable: true
                },
                {
                    label: 'Email',
                    name: 'email',
                    sortable: true
                },
                {
                    label: 'Role',
                    name: 'role.name',
                    sortable: false
                },
                {
                    label: 'Status',
                    name: 'request_access_status',
                    sortable: false
                }
            ]
        },
        views: [listView]
    });

    options.actions.push({
        buttonClass: 'btn btn-default',
        tooltip: 'Login as user',
        template: '<span>Login as user</span>',
        act: function (models) {
            kdLogin.loginAs(models[0].id).catch(function () {
                notify.alert('Failed to login as user.');
            });
        },
        show: function (models) {
            return models.length === 1;
        }
    });

    // uncomment if you want to show the Activate button on the selected user
    /*
    options.actions.push({
        buttonClass: 'btn btn-default',
        tooltip: 'Tooltip',
        template: '<span>{{ $ctrl.model.active ? "Deactivate" : "Activate" }}</span>',
        act: function (models) {
            var user = models[0];
            var status = !user.active;
            user.DSUpdate({active: status});
        },
        show: function (models) {
            return models.length === 1;
        }
    });
    */

    return options;
});
